import {useGetInfiniteReturns} from '@/modules/stocks/returns/api'
import {ReturnsHeader} from '@/modules/stocks/returns/components/returns-header'
import {ReturnsTable} from '@/modules/stocks/returns/components/returns-table'
import {ReturnsSearchSchema} from '@/modules/stocks/returns/schemas'
import {Box} from '@chakra-ui/react'
import {createFileRoute} from '@tanstack/react-router'
import {type OnChangeFn, type SortingState} from '@tanstack/react-table'
import {useCallback} from 'react'

export const Route = createFileRoute('/stocks/returns/')({
  component: ReturnsPage,
  validateSearch: ReturnsSearchSchema,
})

const LIMIT = 50

function ReturnsPage() {
  const search = Route.useSearch()
  const navigate = Route.useNavigate()

  const [sort] = search.sort

  const infiniteReturns = useGetInfiniteReturns({
    limit: LIMIT,
    sort: {
      dir: sort?.desc ? 'desc' : 'asc',
      field: sort?.id || 'createdAt',
    },
    filters: {
      search: search.filters?.search,
      stockLocations: search.filters?.stockLocations,
      status: search.filters?.status,
    },
  })

  const {getPageQuery, getSingleQuery, toStartRow, listContextParams} = infiniteReturns

  const onSortingChange = useCallback<OnChangeFn<SortingState>>(
    updaterOrValue => {
      const newValue = typeof updaterOrValue === 'function' ? updaterOrValue(search.sort) : updaterOrValue
      navigate({to: '.', search: prev => ({...prev, sort: newValue})})
    },
    [navigate, search.sort]
  )

  return (
    <>
      <Box flexShrink={0}>
        <ReturnsHeader />
      </Box>

      <ReturnsTable
        virtualizer={{getPageQuery, getSingleQuery, toStartRow, listContextParams}}
        table={{state: {sorting: search.sort}}}
        sorting={search.sort}
        onSortingChange={onSortingChange}
      />
    </>
  )
}
